import { render, staticRenderFns } from "./BbppDigitalPlatformsBS.vue?vue&type=template&id=2e596a75"
import script from "./BbppDigitalPlatformsBS.vue?vue&type=script&lang=js"
export * from "./BbppDigitalPlatformsBS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports